import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // Import useParams
import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa"; 
import { MdOutlineTune } from "react-icons/md";
import Navbar from '../../components/navbar/general/Navbar';
import ImageCarousel from '../../components/Dashboard/ImageCarousel';
import TurfGrid from '../../components/Dashboard/TurfGrid';
import '../../components/Styles/dashboard.css';

const Dashboard = () => {
  const { location } = useParams(); // Extract location from URL
  const [apiResponse, setApiResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [sortByPrice, setSortByPrice] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const requestData = {
        location: location || 'Chennai',
        search: '',
        pageNo: 0,
        pageSize: 30,
      };

      setIsLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_DASHBOARD_SEARCH_API_URL}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });

        if (response.ok) {
          const data = await response.json();
          setApiResponse(data);
        } else {
          console.error('API Error:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [location]);

  const handleSortByPrice = () => {
    if (!apiResponse || !apiResponse.responseContents) return;

    const sortedTurfs = [...apiResponse.responseContents];
    sortedTurfs.sort((a, b) => {
      const priceA = parseFloat(a.price_Range) || 0;
      const priceB = parseFloat(b.price_Range) || 0;
      return sortByPrice === 'asc' ? priceB - priceA : priceA - priceB;
    });

    setApiResponse({ ...apiResponse, responseContents: sortedTurfs });
    setSortByPrice(sortByPrice === 'asc' ? 'desc' : 'asc'); // Toggle sort order
  };

  return (
    <div className="dashboard-container">
      <Navbar setApiResponse={setApiResponse} />
      <div className="main-content mt-16">
        <ImageCarousel />
        <div className="recommended-section">
          <div className="recommended-header">
            <h2 className="recommended-section-title">Recommended</h2>
            <div className="recommended-actions">
              {sortByPrice === 'asc' ? (
                <FaSortAmountDown className="action-icon" onClick={handleSortByPrice} />
              ) : (
                <FaSortAmountUp className="action-icon" onClick={handleSortByPrice} />
              )}
              <MdOutlineTune className="action-icon" />
              <span className="filter-text">Filter</span>
            </div>
          </div>
          <div className="recommended-section-divider"></div>
          <div className="recommended-grid">
            <TurfGrid turfs={apiResponse?.responseContents || []} isLoading={isLoading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
